import React from 'react';
import { StoryCard } from '../StoryCard';

class PersonalityTestCard extends StoryCard<any> {
	render() {
		return <div className="personality-test-card">{super.renderCard()}</div>;
	}
}

export default PersonalityTestCard;
